const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
const currentYear = (new Date()).getFullYear()
const years = [currentYear]
while (years.length < 21) {
  years.push(years[years.length - 1] + 1)
}
const states = {"AL":"Alabama","AK":"Alaska","AS":"American Samoa","AZ":"Arizona","AR":"Arkansas","CA":"California","CO":"Colorado","CT":"Connecticut","DE":"Delaware","DC":"District Of Columbia","FM":"Federated States Of Micronesia","FL":"Florida","GA":"Georgia","GU":"Guam","HI":"Hawaii","ID":"Idaho","IL":"Illinois","IN":"Indiana","IA":"Iowa","KS":"Kansas","KY":"Kentucky","LA":"Louisiana","ME":"Maine","MH":"Marshall Islands","MD":"Maryland","MA":"Massachusetts","MI":"Michigan","MN":"Minnesota","MS":"Mississippi","MO":"Missouri","MT":"Montana","NE":"Nebraska","NV":"Nevada","NH":"New Hampshire","NJ":"New Jersey","NM":"New Mexico","NY":"New York","NC":"North Carolina","ND":"North Dakota","MP":"Northern Mariana Islands","OH":"Ohio","OK":"Oklahoma","OR":"Oregon","PW":"Palau","PA":"Pennsylvania","PR":"Puerto Rico","RI":"Rhode Island","SC":"South Carolina","SD":"South Dakota","TN":"Tennessee","TX":"Texas","UT":"Utah","VT":"Vermont","VI":"Virgin Islands","VA":"Virginia","WA":"Washington","WV":"West Virginia","WI":"Wisconsin","WY":"Wyoming"}
const amenityIcons = {
  climateControl: {
    src: '/icons/amenities/climate-control.svg',
    alt: 'Snowflake',
    width: 100, height: 100
  },
  driveUp: {
    src: '/icons/amenities/drive-up.svg',
    alt: 'Car',
    width: 100, height: 100
  },
  parking: {
    src: '/icons/amenities/parking.svg',
    alt: 'Parking sign',
    width: 100, height: 100
  },
  pet: {
    src: '/icons/amenities/pet.svg',
    alt: 'Dog',
    width: 100, height: 100
  },
  cornerUnit: {
    src: '/icons/amenities/corner.svg',
    alt: '',
    width: 100, height: 100
  },
  interior: {
    src: '/icons/amenities/interior.svg',
    alt: '',
    width: 100, height: 100
  },
  nearDoor: {
    src: '/icons/amenities/near-door.svg',
    alt: '',
    width: 100, height: 100
  },
  nearManager: {
    src: '/icons/amenities/near-manager.svg',
    alt: '',
    width: 100, height: 100
  },
  rollUpDoors: {
    src: '/icons/amenities/roll-up-door.svg',
    alt: '',
    width: 100, height: 100
  },
  unitAlarms: {
    src: '/icons/amenities/alarms.svg',
    alt: '',
    width: 100, height: 100
  },
  unitElectricity: {
    src: '/icons/amenities/electricity.svg',
    alt: '',
    width: 100, height: 100
  }
}
export {
  months,
  years,
  states,
  amenityIcons
}
